import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { PageTemplateService } from '../services/page-template.service';

export const PageTemplateNewResolver: ResolveFn<any> = async () => {
  try {
    return await inject(PageTemplateService).getBreadCrumbPageTemplateNew();
  } catch {
    return [];
  }
};
